import { render, staticRenderFns } from "./CategoryChild.vue?vue&type=template&id=24ca70c6&"
import script from "./CategoryChild.vue?vue&type=script&lang=js&"
export * from "./CategoryChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports